/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MrfiktivCreateRepairEstimateDtoGen,
  MrfiktivPageViewModelGen,
  MrfiktivRepairEstimateControllerGetParamsGen,
  MrfiktivRepairEstimateViewModelGen,
  MrfiktivUpdateRepairEstimateDtoGen,
  MrfiktivUpdateRepairEstimateStatusDtoGen
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class RepairEstimate<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags repair-estimate
   * @name RepairEstimateControllerCreate
   * @summary (RepairEstimate - CREATE) Create an RepairEstimate
   * @request POST:/partner/{partnerId}/repair-estimate
   * @secure
   * @response `201` `MrfiktivRepairEstimateViewModelGen` The created repairEstimate
   */
  repairEstimateControllerCreate = (
    partnerId: string,
    data: MrfiktivCreateRepairEstimateDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivRepairEstimateViewModelGen, any>({
      path: `/partner/${partnerId}/repair-estimate`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags repair-estimate
   * @name RepairEstimateControllerGet
   * @summary (RepairEstimate - READ) Get all repairEstimates
   * @request GET:/partner/{partnerId}/repair-estimate
   * @secure
   * @response `200` `(MrfiktivPageViewModelGen & { data?: (MrfiktivRepairEstimateViewModelGen)[] })`
   */
  repairEstimateControllerGet = (
    { partnerId, ...query }: MrfiktivRepairEstimateControllerGetParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivPageViewModelGen & { data?: MrfiktivRepairEstimateViewModelGen[] }, any>({
      path: `/partner/${partnerId}/repair-estimate`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags repair-estimate
   * @name RepairEstimateControllerGetOne
   * @summary (RepairEstimate - READ) Get an repairEstimate
   * @request GET:/partner/{partnerId}/repair-estimate/{repairEstimateId}
   * @secure
   * @response `200` `MrfiktivRepairEstimateViewModelGen` The repairEstimate
   */
  repairEstimateControllerGetOne = (partnerId: string, repairEstimateId: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivRepairEstimateViewModelGen, any>({
      path: `/partner/${partnerId}/repair-estimate/${repairEstimateId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags repair-estimate
   * @name RepairEstimateControllerUpdate
   * @summary (RepairEstimate - UPDATE) Updates an repairEstimate
   * @request PATCH:/partner/{partnerId}/repair-estimate/{repairEstimateId}
   * @secure
   * @response `201` `MrfiktivRepairEstimateViewModelGen` The updated repairEstimate
   */
  repairEstimateControllerUpdate = (
    partnerId: string,
    repairEstimateId: string,
    data: MrfiktivUpdateRepairEstimateDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivRepairEstimateViewModelGen, any>({
      path: `/partner/${partnerId}/repair-estimate/${repairEstimateId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags repair-estimate
   * @name RepairEstimateControllerDelete
   * @summary (RepairEstimate - DELETE) Deletes an repairEstimate
   * @request DELETE:/partner/{partnerId}/repair-estimate/{repairEstimateId}
   * @secure
   * @response `200` `MrfiktivRepairEstimateViewModelGen` The deleted repairEstimate
   */
  repairEstimateControllerDelete = (partnerId: string, repairEstimateId: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivRepairEstimateViewModelGen, any>({
      path: `/partner/${partnerId}/repair-estimate/${repairEstimateId}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags repair-estimate
   * @name RepairEstimateControllerUpdateStatus
   * @summary (REPAIR_ESTIMATE - UPDATE) Update status of a repair estimate request as a partner
   * @request PATCH:/partner/{partnerId}/repair-estimate/{repairEstimateId}/status
   * @secure
   * @response `200` `MrfiktivRepairEstimateViewModelGen` The updated repairEstimate
   */
  repairEstimateControllerUpdateStatus = (
    partnerId: string,
    repairEstimateId: string,
    data: MrfiktivUpdateRepairEstimateStatusDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivRepairEstimateViewModelGen, any>({
      path: `/partner/${partnerId}/repair-estimate/${repairEstimateId}/status`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
}
